const config: siteConfig = {
  API_URL: "https://tradeapi.tthefl.com/",
  ENCRYPTION: false,
  ENCRYPTION_KEY: "54686973206973206120736563726574206B657920666F7220656E6372797074696F6E",

};

export default config;
